import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {
  AuthService,
  RoutingConfigService,
  StatePersistenceService,
  StorageSyncType,
} from 'haba-core';
import { CheckoutStepService } from 'haba-featurelibs/checkout/components';
import { UserSignUp } from 'haba-featurelibs/user/profile/root';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SessionStorageKeys } from 'src/app/@enums/storage-keys';

@Injectable({
  providedIn: 'root',
})
export class HabaBillingAddressGuard {
  private userCredits: UserSignUp;

  constructor(
    protected router: Router,
    protected routingConfigService: RoutingConfigService,
    protected checkoutStepService: CheckoutStepService,
    protected statePersistenceService: StatePersistenceService,
    protected authService: AuthService
  ) {}
  canActivate(): Observable<true | UrlTree> {
    this.userCredits = this.statePersistenceService.readStateFromStorage({
      key: SessionStorageKeys.USER_SIGN_UP_CREDENTIALS,
      storageType: StorageSyncType.SESSION_STORAGE,
    });
    return this.authService.isUserLoggedIn().pipe(
      map((loggedIn) => {
        return !!this.userCredits?.password || loggedIn
          ? true
          : this.router.parseUrl(
              this.routingConfigService.getRouteConfig(
                this.checkoutStepService.allSteps[0].routeName
              ).paths?.[0] as string
            );
      })
    );
  }
}
